const initialState = {
    environments: [],
    steps: [],
    validatedCertnames: {},
};

function reducer(state = initialState, action) {
    if (action.type === 'LOGOUT_REQUEST' || action.type === 'AUTHENTICATE_REQUEST') {
        return initialState;
    }

    if (action.type === 'PROVISION_STEPS_SUCCESS') {
        return {
            ...state,
            steps: action.payload,
        };
    }

    if (action.type === 'PROVISION_ENVIRONMENTS_SUCCESS') {
        return {
            ...state,
            environments: action.payload,
        };
    }

    if (action.type === 'VALIDATE_CERTNAME_SUCCESS') {
        const { hostname } = action.actionParams;
        return {
            ...state,
            validatedCertnames: {
                ...state.validatedCertnames,
                [hostname]: action.payload,
            },
        };
    }

    return state;
}

export default reducer;
